import React, { PropsWithChildren, useEffect } from 'react';

import Footer from '../Footer';
import Navbar from '../Navbar';
import Disclaimer from '../Disclaimer';
import { Typography } from '@mui/material';
import { DatePickerLocalizationProvider } from '../../context/DatePickerLocalizationProvider';

import { useTranslation } from 'react-i18next';
import { ExternalLinkProvider } from '../ExternalLink/external-link-provider';
import useShoppingCartContext from '../../context/ShoppingCart/use-shopping-cart-context';
import { ServiceType } from '../../domain/common';

// ********************************************************************************
// Main Container for the layout of the application
export const Layout = (props: PropsWithChildren) => {
  const { i18n } = useTranslation();
  const { cart, removeServiceFromCart } = useShoppingCartContext();

  // NOTE: Using this effect in Layout as it is available in every page of the 
  //       application.
  useEffect(() => {
    // Removing insurance products if the user is not at checkout page
    if (typeof window !== 'undefined' && window.location.pathname.includes('/checkout')) {
      // @ts-ignore
      const insuranceServiceInCart = cart.items.filter((service) => service.type === ServiceType.Insurance);
      insuranceServiceInCart.forEach((service) => {
        removeServiceFromCart(service.item);
      });
    }
  }, []);

  const lang = i18n.language;
  return (
    <DatePickerLocalizationProvider>
      <ExternalLinkProvider>
        {false && <div style={{ backgroundColor: "#F9AA23", padding: "1rem" }}>
          <Typography variant="h2" fontFamily="Gotham-Bold" color="#3F2A55" fontSize="14px" textAlign="left" lineHeight="16px" fontWeight={"bolder"} mt={1}>
            {
              lang === 'en' ?
                "Important Notice for Mexico to USA travelers: Payment suspension for I-94 permit"
                :
                "Aviso importante para viajeros de México a EE.UU: inhabilitación de pago de permiso I-94"
            }
          </Typography>
          <Typography color="#3F2A55" fontSize="14px" textAlign="left" lineHeight="16px" fontWeight={700} mt={1}>
            {
              lang === 'en' ?
                ["The U.S. Customs and Border Protection's ", <a href="https://pay.gov" rel="noopener noreferrer">Pay.gov</a>, " system will be under maintenance on from 11:00 PM (PST) of April 15, 2025, to 01:30 AM (PST) of April 16, 2025. This will affect I-94 permit payments. If you need an I-94, obtain it before that time in the following link:", <a href="https://i94.cbp.dhs.gov/" rel="nopener noreferrer"> https://i94.cbp.dhs.gov/</a>]
                :
                ["El sistema ", <a href="https://pay.gov" rel="noopener noreferrer">Pay.gov</a>, " de la Oficina de Aduanas y Protección Fronteriza de los Estados Unidos estará en mantenimiento el 15 de abril de 2025 de las 11:00 PM (PST) a la 1:30 AM (PST) del 16 de abril de 2025. Esto afectará los pagos del permiso I-94. Si necesita un I-94, obténgalo antes de esa hora en la siguiente liga:", <a href="https://i94.cbp.dhs.gov/" rel="noopener noreferrer">https://i94.cbp.dhs.gov/</a>]
            }
          </Typography>
        </div>}
        <Navbar {...props} />
        <main>{props.children}</main>
        <Footer />
      </ExternalLinkProvider>
    </DatePickerLocalizationProvider>
  );
};
